import * as React from "react";
import TurnrInput from "../TurnrInput.jsx";

export default function SearchInput(props) {
    return <TurnrInput label={"Search"} fullWidth={true} size={"small"} {...props} />;
}
